import { Route, Routes, useNavigate } from "react-router";
import Plano from "./plano";
import Espacios from "./espacios";
import { AppBar, Box, IconButton, Stack, Toolbar, Typography } from "@mui/material";
import Logout from "@mui/icons-material/Logout";
import ArrowBack from '@mui/icons-material/ArrowBack';
import { useState } from "react";

export default function Main({ usuario }) {
  let navigate = useNavigate();

  const [title, setTitle] = useState('');
  const [conBack, setConBack] = useState(false);

  const changeTitle = (newTitle) => {
    setTitle(newTitle);
  }

  const changeConBack = (llevaBack) => {
    setConBack(llevaBack);
  }

  const handleSelectSpace = (selectedId) => {
    console.log('handleSelectSpace(' + selectedId + ')');
    // redirect('/plano:' + selectedId);
    navigate('/plano/' + selectedId);
  }

  const handleBack = () => {
    navigate(-1);
  }

  return (
    <Box sx={{ height: "100vh", display: "flex", flexDirection: "column" }}>
      <AppBar
        position="static"
        color="default"
        elevation={0}
        sx={{ borderBottom: 1, borderColor: "divider" }}
      >
        <Toolbar sx={{ display: "flex", justifyContent: "space-between", gap: 2 }}>
          <Typography variant="h6">{title}</Typography>
          <Stack direction="row">
            {!!conBack ?
              <IconButton aria-label="logout" onClick={handleBack}>
                <ArrowBack />
              </IconButton>
              : !!usuario &&
              <IconButton aria-label="logout">
                <Logout />
              </IconButton>
            }
          </Stack>
        </Toolbar>
      </AppBar>
      <Routes>
        <Route index element={<Espacios changeConBack={changeConBack} changeTitle={changeTitle} onSelectSpace={handleSelectSpace}></Espacios>}></Route>
        <Route path='/plano/:id' element={<Plano changeConBack={changeConBack} changeTitle={changeTitle}></Plano>}></Route>
      </Routes>
    </Box>
    );

  }
